// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36jyB","signatureBlock":"Footer_signatureBlock__1FwRk","signature":"Footer_signature__W3qh3"};